import { useEffect, useState } from "react";
import { BenchMarkData, hotelsService } from "../services/hotelService";

export const useBenchmarkReport = (hotelId: string) => { 
    const [benchmarkData, setBenchmarkData] = useState<BenchMarkData | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (hotelId) {
            fetchHotelBenchmarkReport(hotelId);
        }
    }, [hotelId]);

    const fetchHotelBenchmarkReport = async (hotelId: string) => { 
        try {
            setLoading(true);
            const response = await hotelsService.hotelBenchmarkReport(hotelId);
            setBenchmarkData(response.data);
        } catch (error) {
            console.error("Failed to fetch hotel benchmark report:", error);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        benchmarkData,
        loading
    }
}